import React, {PureComponent} from 'react';
import FormCore from '../../../../components/display/form/formCore';
import PropTypes from 'prop-types';
import moment from 'moment';

class ModalForm extends PureComponent {
  constructor (props) {
    super(props);
    this.props = props;
    this.layout = [
      'inline', // 横向布局
      'vertical', // 弹窗布局
      'horizontal' // 纵向布局
    ];
    this.state = {
      formConfig: {
        childItems: [],
        layout: this.layout[0],
        formTarget: ''
      }
    };
  }

  componentWillReceiveProps (nextProps) {
    // 接受tab传递过来的参数，并注入到表单field值。
    this.formContext && this.formContext.props.form.setFieldsValue({
      'phone': nextProps.param.stubGroupIds
    });
  }

  componentWillMount () {
    // 配置formItem的构建信息
    this.setState({
      formConfig: {
        childItems: [
          {
            type: 'input', // 定义表单元素基础类型
            inputType: 'text', // 定义表单元素的子类型
            param: { // 定义表单元素的参数对象
              name: 'stubGroupId', // 参数名称
              type: 'string' // 参数类型，用来做类型检测
            },
            labelName: '桩群ID', // label名称
            defaultValue: '20170913021', // 设置默认值，同设置disabled则不能修改
            disabled: true, // 功能类似于defaultParams
            radio: { // 设置参数选择器， checked为true则会封装到提交参数对象中
              radioGroup: 'only', // radioGroup 为选择组，相同的radioGroup为一组
              checked: !1
            }
          },
          {
            type: 'areaPicker', // 地区选择组件
            isPickArea: !0, // 设置是否需要选择到区一级
            placeholder: '请选择安装地区',
            pickOnSelect: true, //是否选择即改变
            param: {
              name: 'city',
              type: 'array'
            },
            required: !1, // 注意带有条件radio的formItem，不可以设置为必填
            labelName: '安装地区',
			  className:'allshow',
            radio: {
              radioGroup: 'only',
              checked: !1
            }
          },
          {
            type: 'radio',
            labelName: '电桩类型',
            param: {
              name: 'stubType',
              type: 'string'
            },
            options: [
              {
                text: '公桩',
                value: '0'
              },
              {
                text: '私桩',
                value: '1'
              }
            ],
            required: !0
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: '我由对应信息控制显示',
            param: {
              name: 'username',
              type: 'string'
            },
            required: !0,
            validator: { // 自定义校验对象
              vtype: 'length', // 校验名称
              min_val: 4, // 规则参数
              max_val: 20
            },
            labelName: '报修人',
            visibleRule: { // 显示规则
              name: 'selectInfo', // 受影响的参数名称
              value: '1' // 设置显示规则，根据触发组件的paramName的变化来设置规则
            }
          },
          {
            type: 'date',
            dateType: 'pickDate',
            placeholder: '请选择安装日期',
            param: {
              name: 'installDate',
              type: 'object'
            },
            defaultValue: moment('2018-09-09'), // 设置默认日期
            range: [3, 0], // 3 为从今天往前推3天， 0 为今天
            labelName: '安装日期',
            required: !0
          },
          {
            type: 'date',
            dateType: 'pickDateTime',
            placeholder: '我由电桩类型控制',
            param: {
              name: 'installDateTime',
              type: 'object'
            },
            labelName: '日期带时间',
            visibleRule: {
              name: 'stubType',
              value: '1' // 设置显示规则，根据触发组件的paramName的变化来设置规则
            }
          },
          {
            type: 'date',
            dateType: 'rangeDate',
            placeholder: '请选择日期范围',
            param: {
              name: 'dateScope',
              type: 'array'
            },
            range: [3, -7],
            labelName: '日期范围',
            required: !0
          },
          {
            type: 'date',
            dateType: 'rangeDateTime',
            param: {
              name: 'dateScopeTime',
              type: 'array'
            },
            labelName: '日期范围带时间',
            radio: {
              radioGroup: 'only2', // 设置选择组
              checked: !1
            }
          },
          {
            type: 'input',
            inputType: 'tel',
            placeholder: '请输入手机号码',
            param: {
              name: 'phone',
              type: 'string'
            },
            validator: {
              vtype: 'phone'
            },
            defaultValue: this.props.param.stubGroupIds,
            labelName: '联系电话',
            radio: {
              radioGroup: 'only2',
              checked: !0
            }
          },
          {
            type: 'input',
            inputType: 'textarea',
            placeholder: '请输入备注信息',
            defaultValue: '小明，快去吃羊肉串',
            param: {
              name: 'desc',
              type: 'string'
            },
            required: !0,
            validator: {
              vtype: 'length',
              min_val: 4,
              max_val: 50
            },
            labelName: '备注信息',
          },
          {
            type: 'buttonGp', // 表单最终执行组
            buttonArr: [
              {
                btnType: 'submit',
                text: '查询'
              },
              {
                btnType: 'reset',
                text: '清空'
              }
            ]
          },
        ], // 设置表单元素
        layout: this.layout[this.props.layout] || this.layout[2], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
        formTarget: 'refresh', // 表单提交类型，设置form则为更新表单
        defaultParams: { // 多个默认参数可以在这里设置，不需要使用disabled
          id: '201788888',
          defaultName: '123123'
        },
        dispatchFields: (e) => {
          this.formContext = e;
        },
        context: this
      }
    });
  }

  fetchApi (param) {
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === 'grid') {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      // TODO 执行异步请求或其他
      return;
    }
  }

  render () {
    return <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi.bind(this)}/>
  }
}

export default ModalForm;

ModalForm.propsType = {
  layout: PropTypes.string,
  modalSubmit: PropTypes.func,
  param: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo_2/forms/modalForm.js